import { create } from "zustand";
import { persist } from "zustand/middleware";
export const useForm = create(persist(
    (set)=>({
        formData: {
            username: '',
            password: '',
            rememberMe: false
        },
        setFormdata: (payload)=>set((state)=>({
            formData: {...state.formData, ...payload}
        }))
    }),
    {name: 'form'}
))